import React from "react";
import { Navigate } from "react-router-dom";

// Wrapper component to protect routes
const ProtectedRoute = ({ children }) => {
const token = localStorage.getItem("access_token");

const isValidToken =
  typeof token === "string" &&
  token.trim() !== "" &&
  token !== "null" &&
  token !== "undefined";

if (!isValidToken) {
  return <Navigate to="/login" replace />;
}
return children;

};


export default ProtectedRoute;
